import { Sparkles, Truck, ShoppingBag } from "lucide-react";

const HERO_IMG =
    "https://customer-assets.emergentagent.com/job_creaciones-pro/artifacts/0dh9lodm_historia.webp";

export default function Hero() {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative pt-28 pb-20 lg:pt-36 lg:pb-28 opteris-grain overflow-hidden"
        >
            {/* Decorative blobs */}
            <div className="absolute -top-20 -left-20 w-72 h-72 rounded-full bg-[#f49c8b]/30 blur-3xl pointer-events-none" />
            <div className="absolute top-20 right-0 w-80 h-80 rounded-full bg-[#ea4d87]/20 blur-3xl pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                    {/* LEFT: Text */}
                    <div className="lg:col-span-7 fade-up">
                        <span
                            data-testid="hero-chip"
                            className="opteris-chip"
                        >
                            <Sparkles size={12} /> Papelería & Suministros de
                            Oficina
                        </span>

                        <h1
                            data-testid="hero-heading"
                            className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6 leading-[1.05]"
                        >
                            Tu aliado estratégico en{" "}
                            <span className="opteris-gradient-text">
                                papelería
                            </span>{" "}
                            y{" "}
                            <span className="text-[#f4861c]">
                                suministros de oficina
                            </span>
                        </h1>

                        <p
                            data-testid="hero-subtitle"
                            className="mt-6 text-base sm:text-lg text-gray-600 leading-relaxed max-w-xl"
                        >
                            En Creaciones Opteris transformamos cualquier
                            espacio de trabajo o estudio en un entorno de alta
                            productividad. Comercialización integral de
                            artículos de papelería y suministros de oficina,
                            al por menor y al por mayor.
                        </p>

                        {/* Mini stats */}
                        <div className="mt-12 grid grid-cols-3 gap-6 max-w-md">
                            <Stat
                                icon={<Truck size={18} />}
                                number="Mayoreo"
                                label="y Menudeo"
                            />
                            <Stat
                                icon={<ShoppingBag size={18} />}
                                number="100%"
                                label="Calidad"
                            />
                            <Stat
                                icon={<Sparkles size={18} />}
                                number="24/7"
                                label="Abasto continuo"
                            />
                        </div>
                    </div>

                    {/* RIGHT: Image composition */}
                    <div className="lg:col-span-5 fade-up">
                        <div className="relative">
                            <div className="relative rounded-[2rem] overflow-hidden shadow-2xl border border-white/60">
                                <img
                                    src={HERO_IMG}
                                    alt="Suministros de oficina modernos"
                                    className="w-full h-[480px] object-cover"
                                    data-testid="hero-image"
                                />
                                <div className="absolute inset-0 bg-gradient-to-tr from-[#ea4d87]/15 via-transparent to-[#f4861c]/10" />
                            </div>

                            {/* Floating card */}
                            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-5 border border-gray-100 max-w-[240px] float-anim">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-full bg-[#f4861c]/10 flex items-center justify-center">
                                        <Truck
                                            size={20}
                                            className="text-[#f4861c]"
                                        />
                                    </div>
                                    <div>
                                        <div className="font-display font-bold text-sm">
                                            Logística robusta
                                        </div>
                                        <div className="text-xs text-gray-500">
                                            Entrega directa
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Floating chip */}
                            <div className="absolute -top-4 -right-4 bg-[#ea4d87] text-white rounded-full px-4 py-2 text-xs font-bold shadow-lg">
                                Guadalajara, Jal.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

function Stat({ icon, number, label }) {
    return (
        <div className="flex flex-col">
            <div className="w-9 h-9 rounded-lg bg-[#f4861c]/10 text-[#f4861c] flex items-center justify-center mb-2">
                {icon}
            </div>
            <div className="font-display font-bold text-sm text-[#1a1a1a]">
                {number}
            </div>
            <div className="text-xs text-gray-500">{label}</div>
        </div>
    );
}
